<div class="iframe-container">
  <iframe class="full-width" style="" src="https://www.iubenda.com/terms-and-conditions/85763951"></iframe>
</div>
